import React from "react";
import { useLocation, Link, useNavigate } from "react-router";
import formatMoney from "/src/helpers/formatMoney";
import { useApi } from "/src/helpers/Hooks/useApi";
import SecureTradingCheckout from "/src/components/SecureTradingCheckout.jsx";
import { track } from "/src/helpers/analytics";

const PaymentCheckoutPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const amount = location.state?.amount;
    const details = location.state?.details;
    const outstanding = location.state?.outstanding;
    const api = useApi();

    const onApproved = async (responseJwt) => {
        await api.processPayment(responseJwt);
        track("balance_payment_completed", {
            payment_type: "balance", currency: "GBP", value: Number(amount),
            outstanding_before: outstanding ?? null,
            outstanding_after: outstanding != null ? Math.max(0, Math.round((outstanding - Number(amount)) * 100) / 100) : null,
            full_payment: outstanding != null ? Number(amount) >= outstanding - 0.005 : null
        });
        navigate(`/payment`, { state: { paymentSuccess: true } });
    };

    if (!amount) {
        return (
            <div className="bg-white rounded-card p-6 text-center">
                <p className="text-content_2 mb-4">No payment amount specified.</p>
                <Link to="/payment" className="text-emp hover:text-emp_dark font-semibold transition">
                    Go back to Payments
                </Link>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-card p-6 text-center">
            <div className="text-emp mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
            </div>
            <h1 className="text-2xl font-poppins font-semibold text-primary mb-2">Processing Payment</h1>
            <p className="text-content_2 text-lg mb-5">
                You are making a payment of <span className="font-semibold text-primary">£{formatMoney(amount)}</span>
            </p>
            <SecureTradingCheckout
                amount={amount}
                customerDetails={details}
                payButtonText={`Pay £${formatMoney(amount)}`}
                onApproved={onApproved}
            />
        </div>
    );
};

export default PaymentCheckoutPage;
